"use client";

import CartIcon from "@/assets/svg/CartIcon.svg";
import { getCartOrder } from "@/utils/storage";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export const ShoppingCartButton = () => {
  const pathname = usePathname();
  const [cartId, setCartId] = useState(null);

  useEffect(() => {
    setCartId(getCartOrder());
  }, [pathname]);

  return (
    <a
      aria-label="Cart Button"
      className="uppercase relative text-[#8f8f8f] hover:text-gray-700 font-bold transition-colors duration-100 text-lg"
      href={cartId ? `/cart/${cartId}` : "/cart"}
    >
      <CartIcon height={20} width={20} className="lg:h-6 lg:w-6 h-[25px] w-[25px]" />
      <div
        id="cart-items"
        className="absolute -top-2 -right-2 rounded-full text-white text-xs font-normal bg-blue-500 h-5 min-w-5 flex
               items-center justify-center"
      >
        0
      </div>
    </a>
  );
};
